import { httpsCallable } from 'firebase/functions';
import { AppThunk } from '../../../index';
import {
  sendVerificationEmailFailed,
  sendVerificationEmailStarted,
  sendVerificationEmailSuccess,
} from '../reducer';

export const resendVerificationEmail =
  (continueUrl: string): AppThunk =>
  async (dispatch, _, { auth, functions }) => {
    const email = auth().currentUser?.email;

    if (!email) {
      return;
    }

    dispatch(sendVerificationEmailStarted());
    try {
      await httpsCallable(functions, 'users-sendVerificationEmail')({ email, continueUrl });
      dispatch(sendVerificationEmailSuccess());
    } catch (e) {
      dispatch(sendVerificationEmailFailed((e as { code?: string }).code || 'unknown'));
    }
  };
